export default "__VITE_ASSET__3yc_FWPi__"